// src/app/core/service/auth-tab-sync.service.ts

import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class AuthTabSyncService {
  private channel = new BroadcastChannel("app_auth_channel");
  private alertOpened = false;

  constructor(
    private router: Router,
    private ngZone: NgZone,
  ) {
    this.listenForChanges();
  }

  // Notify all tabs after successful login
  notifyLogin(): void {
    this.channel.postMessage({
      type: "USER_LOGGED_IN",
    });
  }

  // Notify all tabs after logout
  notifyLogout(): void {
    this.channel.postMessage({
      type: "USER_LOGGED_OUT",
    });
  }

  private listenForChanges(): void {
    this.channel.onmessage = (event) => {
      this.ngZone.run(() => {
        switch (event.data?.type) {
          case "USER_LOGGED_IN":
            // Only show popup on Signin page
            if (
              this.router.url.includes("/authentication/signin") &&
              !this.alertOpened
            ) {
              this.alertOpened = true;

              Swal.fire({
                title: "Login Detected in Another Tab!",
                text: "You are already logged in from another tab. Please logout first to switch user.",
                icon: "info",
                confirmButtonText: "Log out",
                cancelButtonText: "Cancel",
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                heightAuto: false,
              }).then((result) => {
                this.alertOpened = false;

                this.ngZone.run(() => {
                  if (result.isConfirmed) {
                    console.log("Logout clicked");

                    localStorage.clear();

                    this.notifyLogout();

                    this.router.navigateByUrl("/authentication/signin");
                  } else {
                    console.log("Dashboard clicked");

                    this.router
                      .navigateByUrl("/coremodule/Dashboard")
                      .then((success) => {
                        console.log("Dashboard Navigation:", success);
                      });
                  }
                });
              });
            }

            break;

          case "USER_LOGGED_OUT":
            console.log("Logout received from another tab");

            localStorage.clear();

            Swal.close();

            this.router.navigateByUrl("/authentication/signin");

            break;
        }
      });
    };
  }
}
